import { useApp } from "../app/AppContext";
import { JotsWidget } from "./JotsWidget";

const RING = 2 * Math.PI * 47;
const PRESETS: [number, number][] = [
  [25, 5],
  [52, 17],
  [90, 20],
];

export function AsideRail() {
  const app = useApp();
  const { timer } = app;
  const total = (timer.mode === "work" ? timer.workMin : timer.brkMin) * 60;
  const mm = String(Math.floor(timer.left / 60)).padStart(2, "0");
  const ss = String(timer.left % 60).padStart(2, "0");
  const openTasks = app.tasks.filter((t) => t.status !== "done");

  return (
    <aside className="aside">
      <div className="h">Focus timer</div>
      <div className="timer">
        <div className="tring">
          <svg width="112" height="112" viewBox="0 0 112 112">
            <circle cx="56" cy="56" r="47" fill="none" stroke="var(--surface2)" strokeWidth="6" />
            <circle
              cx="56"
              cy="56"
              r="47"
              fill="none"
              stroke={timer.mode === "work" ? "var(--accent)" : "var(--ok)"}
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={RING}
              strokeDashoffset={RING * (timer.left / total)}
              style={{ transform: "rotate(-90deg)", transformOrigin: "center" }}
            />
          </svg>
          <div className="tv">
            {mm}:{ss}
          </div>
        </div>
        <div className="tmode" style={{ color: timer.mode === "work" ? "var(--accent)" : "var(--ok)" }}>
          {timer.mode === "work" ? "focus" : "break"}
        </div>
        <div className="presets">
          {PRESETS.map(([w, b]) => (
            <button
              key={w}
              className={`preset${timer.workMin === w ? " on" : ""}`}
              onClick={() => timer.setPreset(w, b)}
            >
              {w}/{b}
            </button>
          ))}
        </div>
        <select
          className="sel2"
          value={timer.linkedTaskId ?? ""}
          onChange={(e) => timer.setTask(e.target.value || null)}
        >
          <option value="">— link a task —</option>
          {openTasks.map((t) => (
            <option key={t.id} value={t.id}>
              {t.title.slice(0, 36)}
            </option>
          ))}
        </select>
        <div className="tctl">
          <button className="mbtn" onClick={() => timer.toggle()}>
            {timer.running ? "Pause" : "Start"}
          </button>
          <button className="mbtn ghost" onClick={() => app.openFocus(timer.linkedTaskId ?? undefined)}>
            Focus mode
          </button>
        </div>
      </div>

      <div className="h" style={{ marginTop: 22 }}>
        Rituals
      </div>
      <div style={{ fontSize: 12.5 }}>
        {app.todayLog?.planned ? (
          <div className="shdone" style={{ fontSize: 13, padding: "4px 0" }}>
            ☀ Planned
          </div>
        ) : (
          <button className="mini" style={{ width: "100%", marginBottom: 6 }} onClick={() => app.openPlan()}>
            ☀ Plan the day
          </button>
        )}
        {app.todayLog?.shutdown ? (
          <div className="shdone" style={{ fontSize: 13, padding: "4px 0" }}>
            🌙 Shutdown complete
          </div>
        ) : (
          <button className="mini" style={{ width: "100%" }} onClick={() => app.openShutdown()}>
            🌙 Shutdown ritual
          </button>
        )}
      </div>

      <JotsWidget />
    </aside>
  );
}
